import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface AlertDialogData {
  title: string;
  message: string;
  confirmButtonText?: string;
  confirmButtonVariant?: 'primary' | 'theme' | 'dark' | 'danger' | 'link';
}

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrl: './alert-dialog.component.scss',
})
export class AlertDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: AlertDialogData) {}

  get title(): string {
    return this.data?.title;
  }

  get message(): string {
    return this.data?.message;
  }

  get confirmButtonText(): string {
    return this.data?.confirmButtonText;
  }

  get confirmButtonVariant(): 'primary' | 'theme' | 'dark' | 'danger' | 'link' {
    return this.data?.confirmButtonVariant || 'theme';
  }
}
